import { render, staticRenderFns } from "./Prizes.vue?vue&type=template&id=4b056741&scoped=true&"
import script from "./Prizes.vue?vue&type=script&lang=ts&"
export * from "./Prizes.vue?vue&type=script&lang=ts&"
import style0 from "./Prizes.vue?vue&type=style&index=0&id=4b056741&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b056741",
  null
  
)

export default component.exports